import { useParams, useSearchParams } from "react-router-dom";
import MinuteByMinute from "../components/minuteByMinute/minuteByMinute";

export default function MinuteByMinutePage() {
  const { type, match } = useParams();
  const [searchParams] = useSearchParams();
  
  // Leer parámetros de la query string
  const refresh = searchParams.get("refresh") === "true";
  const country = searchParams.get("country");

  return (
    <div className="">
      <MinuteByMinute type={type} matchId={match} refresh={refresh} country={country} />
    </div>
  );
}